import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import { m } from 'framer-motion';
import { useLocales } from "../../locales";

const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
};

const CookieConsent = () => {
    const [showConsent, setShowConsent] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        const userConsent = getCookie('userConsent');
        if (!userConsent) {
            setShowConsent(true);
        }
    }, []);

    const { translate } = useLocales();

    const handleAcceptCookies = () => {
        document.cookie = "userConsent=true; max-age=31536000; path=/";
        setShowConsent(false);
    };

    const handleRejectCookies = () => {
        document.cookie = "userConsent=false; max-age=31536000; path=/";
        setShowConsent(false);
    };

    return (
        showConsent && (
            <Box
                component={m.div}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 50 }}
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                    padding: isMobile ? '10px' : '20px',
                    boxSizing: 'border-box',
                }}
            >
                <Box
                    sx={{
                        width: isMobile ? '95%' : '80%',
                        maxWidth: '400px',
                        backgroundColor: 'white',
                        padding: '15px',
                        borderRadius: '10px',
                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="body1" mb={2}>
                        {translate("cookieInfo")}
                    </Typography>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleRejectCookies}
                        sx={{ marginRight: '10px', width: '100px' }}
                    >
                        {translate("reject")}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ width: '100px' }}
                        onClick={handleAcceptCookies}
                    >
                        {translate("accept")}
                    </Button>
                </Box>
            </Box>
        )
    );
};

export default CookieConsent;
